import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import Divider from '@material-ui/core/Divider';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import StripeButton from '../../components/atoms/StripeButton';
import ValidationText from '../../components/atoms/ValidationText';
import DepositRegisterEditConfirm from './DepositRegisterEditConfirm';
import {
  getShops,
  editShop,
  addShopImage,
  countShopEmail
} from '../../actions/Shop';
import { editDepositRegister } from '../../actions/Deposits';
import { sendLogin, getCurrentUserInfo } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px',
    height: '4px'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  descriptionSmall: {
    fontSize: '0.875rem',
    color: '#707070',
    margin: '10px 0px 0px'
  },
  subDescription: {
    fontSize: '0.875rem'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell90: {
    width: '90%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  depositManageInfo: {
    paddingTop: '1.5rem',
    color: 'red',
    fontWeight: 'bold'
  },
  hrMargin: {
    marginBottom: '16px'
  },
  textRed: {
    color: 'red'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      statuses: state.shops.statuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getShops,
          editShop,
          addShopImage,
          countShopEmail,
          editDepositRegister,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('enableSmsAuthentication', 'setEnableSmsAuthentication', false),
  withState('shopId', 'setShopId', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    '銀行口座で直接受取（月1回入金）（オプション）'
  ),
  withState('bankAccountId', 'setBankAccountId', ''),
  withState('bankName', 'setBankName', ''),
  withState('bankNameError', 'setBankNameError', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankBranchNameError', 'setBankBranchNameError', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      getCurrentUserInfo().then(user => {
        this.props.setEnableSmsAuthentication(
          typeof user.attributes.phone_number_verified === 'undefined' ||
            !user.attributes.phone_number_verified
        );
      });
      const depositManageStripe = this.props.editInput.accountStatus
        .stripeAccount
        ? 'SELF'
        : this.props.editInput.depositManage;
      const depositManageStripeStr = this.props.editInput.accountStatus
        .stripeAccount
        ? 'Stripe経由で受取（週1回入金）'
        : this.props.editInput.depositManageStr;
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setDepositManage(
        this.props.editInput.depositManage === 'NOT_MANAGE'
          ? 'NONSELF'
          : depositManageStripe
      );
      this.props.setDepositManageStr(
        this.props.editInput.depositManage === 'NOT_MANAGE'
          ? '銀行口座で直接受取（月1回入金）（オプション）'
          : depositManageStripeStr
      );
      this.props.setBankAccountId(this.props.editInput.bankAccountId);
      this.props.setBankName(this.props.editInput.bankName);
      this.props.setBankBranchName(this.props.editInput.bankBranchName);
      this.props.setBankAccountType(
        this.props.editInput.bankAccountType === null
          ? 'SAVINGS'
          : this.props.editInput.bankAccountType
      );
      this.props.setBankAccountTypeStr(
        this.props.editInput.bankAccountTypeStr === null
          ? '普通預金'
          : this.props.editInput.bankAccountTypeStr
      );
      this.props.setBankAccountNumber(this.props.editInput.bankAccountNumber);
      this.props.setBankAccountHolder(this.props.editInput.bankAccountHolder);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
    }
  })
);

const Main = enhance(
  ({
    classes,
    editInput,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    enableSmsAuthentication,
    shopId,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankAccountId,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    updatedAt,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError
  }) => {
    const enableShopBank = editInput.bankSwitchable;

    const editConfirm = {
      shopId,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder
    };
    const bankAccount = {
      bankAccountId,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder
    };
    const editParam = {
      depositManage,
      bankAccount,
      firstRegister: enableSmsAuthentication,
      updatedAt
    };

    const errors = {
      bankNameError,
      bankBranchNameError,
      bankAccountNumberError,
      bankAccountHolderError
    };

    const validBankName = () => {
      const value = bankName;
      if (enableShopBank && depositManage === 'NONSELF' && !value) {
        setBankNameError('必須項目です。');
        return 1;
      }
      setBankNameError('');
      setBankName(value);
      return 0;
    };
    const validBankBranchName = () => {
      const value = bankBranchName;
      if (enableShopBank && depositManage === 'NONSELF' && !value) {
        setBankBranchNameError('必須項目です。');
        return 1;
      }
      setBankBranchNameError('');
      setBankBranchName(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const valid = () => {
      const errorCount =
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const convertDepositManageStr = mode => {
      if (mode === 'SELF') {
        setDepositManageStr('Stripe経由で受取（週1回入金）');
      } else {
        setDepositManageStr('銀行口座で直接受取（月1回入金）（オプション）');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };
    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = async () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">入金情報登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <Typography component="p" className={classes.description}>
                  入金管理
                </Typography>
                {!enableShopBank && (
                  <Typography className={classes.descriptionSmall}>
                    ※&nbsp;グループで銀行口座を管理しているため、入金管理の設定・表示を行うことはできません。
                  </Typography>
                )}
                <RadioGroup
                  value={depositManage}
                  onChange={e => {
                    setDepositManage(e.target.value);
                    convertDepositManageStr(e.target.value);
                  }}
                >
                  <div className={classes.depositManageDiv}>
                    <FormControlLabel
                      value="SELF"
                      control={
                        <Radio
                          color="primary"
                          disabled={
                            !enableShopBank ||
                            editInput.accountStatus.stripeAccount
                          }
                        />
                      }
                      label="Stripe経由で受取（週1回入金）"
                    />
                    <span className={classes.depositManageInfo}>
                      支払いサイクルが早く(週次)なります
                    </span>
                    <Typography className={classes.subDescription}>
                      Stripe紐付けを行うことで、振込サイクルの変更や入金日のご確認ができるようになります
                    </Typography>
                  </div>
                  <div>
                    <FormControlLabel
                      value="NONSELF"
                      control={
                        <Radio
                          color="primary"
                          disabled={
                            !enableShopBank ||
                            editInput.accountStatus.stripeAccount
                          }
                        />
                      }
                      label="銀行口座で直接受取（月1回入金）（オプション）"
                    />
                    <Typography className={classes.subDescription}>
                      月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は貴社負担）。
                      <br />
                      後から「自社で入金を管理する」へ変更することも可能です。
                    </Typography>
                  </div>
                </RadioGroup>
              </TableCell>
            </TableRow>
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="銀行名"
                    defaultValue={editInput.bankName}
                    disabled={!enableShopBank}
                    placeholder="○○銀行"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankName(e.target.value);
                    }}
                    onBlur={validBankName}
                  />
                  <ValidationText message={errors.bankNameError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="支店名"
                    defaultValue={editInput.bankBranchName}
                    disabled={!enableShopBank}
                    placeholder="○○支店"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankBranchName(e.target.value);
                    }}
                    onBlur={validBankBranchName}
                  />
                  <ValidationText message={errors.bankBranchNameError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <Typography className={classes.description}>
                    口座種別
                  </Typography>
                  <RadioGroup
                    row
                    value={bankAccountType}
                    onChange={e => {
                      setBankAccountType(e.target.value);
                      convertBankAccountTypeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="SAVINGS"
                      control={
                        <Radio color="primary" disabled={!enableShopBank} />
                      }
                      label="普通預金"
                    />
                    <FormControlLabel
                      value="CHECKING"
                      control={
                        <Radio color="primary" disabled={!enableShopBank} />
                      }
                      label="当座預金"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="口座番号"
                    defaultValue={editInput.bankAccountNumber}
                    disabled={!enableShopBank}
                    placeholder="1234567"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountNumber(e.target.value);
                    }}
                    onBlur={validBankAccountNumber}
                  />
                  <ValidationText message={errors.bankAccountNumberError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="口座名義"
                    defaultValue={editInput.bankAccountHolder}
                    disabled={!enableShopBank}
                    placeholder="ヤマダ　タロウ"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountHolder(e.target.value);
                    }}
                    onBlur={validBankAccountHolder}
                  />
                  <ValidationText message={errors.bankAccountHolderError} />
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  必ず漢字/ひらがな以外でご記入ください。
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'SELF' &&
              enableShopBank &&
              !editInput.accountStatus.stripeAccount && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <Divider className={classes.hrMargin} />
                    <StripeButton />
                    <br />
                    {editInput.email}
                    <br />
                    <div className={classes.textRed}>
                      下記、Stripeで登録するメールアドレスは、こちらに表示されているごちめし登録のメールアドレスと同一のメールアドレスで、登録してください。
                      <br />
                      （ごちめしとStripeを紐付けるには2つのメールアドレスが一致している必要があります。）
                    </div>
                    <br />
                    第3者の決済サービス「Stripe&nbsp;Connect」を利用して頂く事で、自社で入金サイクル（基本は毎週）を変更したり、振込手数料を無料にする事ができます。こちらのオプションを選んだ場合は、以下の設定を行って頂きます。
                    <br />
                    <br />
                    ①&nbsp;Stripeでアカウントを作成する。
                    <br />
                    ②&nbsp;ごちめしを運営する当社のStripeアカウントに紐付けを行う。
                    <br />
                    ③&nbsp;初回入金時に、Stripe社より送られる案内メールにしたがって、本人確認資料を提出する。
                    <br />
                    <br />
                    上部のConnect&nbsp;with&nbsp;Stripeボタン、もしくは管理画面左上の三本線メニューから、「その他」→「自社で入金管理（オプション）」を選んで頂くと、上記の①および②の設定が一度に行う事ができます。設定の詳細については、当管理システムのトップページから「ごちめし店舗登録マニュアルはこちら」をご参照ください。
                  </TableCell>
                </TableRow>
              )}
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton
            onClickAction={confirmAction}
            consent={enableShopBank || enableSmsAuthentication}
          />
        </div>
        <Modal open={openEditConfirm}>
          <DepositRegisterEditConfirm
            backAction={backAction}
            editConfirm={editConfirm}
            editParam={editParam}
            enableShopBank={enableShopBank}
            enableSmsAuthentication={enableSmsAuthentication}
            updateOpenEditModal={updateOpenEditModal}
            updateOpenEditConfirm={updateOpenEditConfirm}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
